export { default } from "./CollapsibleBlock";
